import { EarningsInsightRecapResponse, earningsInsights } from '@api';
import { getTimeTillEndOfDayMs } from '@helpers';
import { useQueries, useQuery } from '@tanstack/react-query';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export const QUERY_KEY_EARNINGS_INSIGHT_RECAP =
  'QUERY_KEY_EARNINGS_INSIGHT_RECAP';

const fetchEarningsInsightRecap = (
  earningsInsightId: string,
  signal?: AbortSignal
) => {
  const { path, schema } = earningsInsights.getEarningsInsightRecap;
  return wretchRequest<EarningsInsightRecapResponse>(path(earningsInsightId), {
    method: 'get',
    schema,
    signal,
  });
};

export const useGetEarningsInsightRecap = (earningsInsightId: string) =>
  useQuery({
    queryKey: [QUERY_KEY_EARNINGS_INSIGHT_RECAP, earningsInsightId],
    queryFn: ({ signal }) =>
      fetchEarningsInsightRecap(earningsInsightId, signal),
    staleTime: getTimeTillEndOfDayMs(),
    enabled: !!earningsInsightId,
  });

export const useEarningsInsightRecaps = (earningsInsightIds: string[]) =>
  useQueries({
    queries: earningsInsightIds.map(earningsInsightId => ({
      queryKey: [QUERY_KEY_EARNINGS_INSIGHT_RECAP, earningsInsightId],
      queryFn: ({ signal }: { signal?: AbortSignal }) =>
        fetchEarningsInsightRecap(earningsInsightId, signal),
      staleTime: getTimeTillEndOfDayMs(),
    })),
    combine: results => ({
      data: results
        .map(result => result.data)
        .filter((data): data is EarningsInsightRecapResponse => data != null),
      isFetching: results.some(result => result.isFetching),
    }),
  });
